import type { SchemaChatResolver_GetChats } from 'cpool-tables/backend-resolvers';

export const isPartnerChat = (chat: Pick<SchemaChatResolver_GetChats[number], 'partnerIds'>): boolean =>
    chat.partnerIds.length > 0;
